module.exports = __webpack_public_path__ + "img/function-image-ingredient.81f8cce5.svg";